// Components
import Swiper  from "../../libs/swiper-6.6.2/swiper-bundle";
import mixitup from "../../libs/mixitup/dist/mixitup.min";

import { VideoFrame }          from "../_components/_video-frame";
import { FilterMixitMobile }   from "../_components/_filter-mixit-mobile";
import { SliderArticles }      from "../_components/_slider-articles";
import { WebinarsIsotope }     from "../_components/_webinars-isotope";
import { MyAccountMenuSlider } from "../_components/_my-account-menu";

window.$ = jQuery;
window.Swiper = Swiper;
window.mixitup = mixitup;

$( document ).ready( function () {
	VideoFrame();
	WebinarsIsotope();
	FilterMixitMobile();
	MyAccountMenuSlider();

	SliderArticles();
} );